import * as yup from 'yup';

export const schemaDentalTreatmentCreate = yup.object().shape({
  type: yup.number().required('Tipo obrigatória'),
  client_id: yup.string().required('Cliente obrigatório'),
  total: yup
    .number()
    .min(1, 'Valor deve ser maior que zero')
    .required('Valor obrigatório'),
  professional_id: yup.string().required('Profissional obrigatório'),
  items: yup
    .array()
    .min(1, 'Deverá ter pelo menos um procedimento')
    .required('Item obrigatório'),
});
